import { createRoot } from 'react-dom/client';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';

import PortalApp from './portal/PortalApp';
import './app.css';

const container = document.getElementById('root');
if (!container) {
  throw new Error('index.html is missing the #root mount point');
}

/*
 * One surface. The portal is the customer UI; every other address is a way of
 * asking for it.
 *
 * There were two. `/` held a placeholder that reported what the backend said
 * about itself — there to prove the design-system token pipeline and the
 * frontend-to-backend seam worked before any real surface was built on them —
 * and the portal was being built behind it, deliberately unlinked. That
 * placeholder's own docstring said the subscription, fleet and billing views
 * would replace it. They have, so it is gone.
 *
 * In the deployed shape the server redirects `/` to `/portal/` before this
 * file runs at all (commerce/urls.py). The redirect below is what makes `npm
 * run dev` behave the same way, and what answers an address the app does not
 * know rather than rendering nothing at all.
 */
createRoot(container).render(
  <BrowserRouter>
    <Routes>
      <Route path="/portal/*" element={<PortalApp />} />
      <Route path="*" element={<Navigate to="/portal" replace />} />
    </Routes>
  </BrowserRouter>,
);
